import { graphql, useStaticQuery } from "gatsby"

export const useAllBlogs = (locale) => {
  const { allCosmicjsBlogs } = useStaticQuery(graphql`
    query {
      allCosmicjsBlogs {
        edges {
          node {
            id
            slug
            title
            locale
            type
            content
          }
        }
      }
    }
  `)

  const allItems = allCosmicjsBlogs.edges.map(({ node }, index) => ({
    key: index,
    ...node,
  }))

  if (!locale) {
    return allItems
  }

  return allItems.filter((item) => item.locale === locale)
}
